import { render, staticRenderFns } from "./CreateTerminalVirtualAccount.vue?vue&type=template&id=78101af6&scoped=true"
import script from "./CreateTerminalVirtualAccount.vue?vue&type=script&lang=js"
export * from "./CreateTerminalVirtualAccount.vue?vue&type=script&lang=js"
import style0 from "./CreateTerminalVirtualAccount.vue?vue&type=style&index=0&id=78101af6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78101af6",
  null
  
)

export default component.exports